import { jsx } from "react/jsx-runtime";
import { Checkbox } from "@wix/wix-ui-tpa/cssVars";
import { useConfig } from "../../contexts/config-context.js";
import { useTranslation } from "../../contexts/translation-context.js";
import { formatCurrency } from "../../utils/format-currency.js";
import { getCurrencyAriaLabel } from "../shared/payment-field-utils.js";
import { BoxSelectionItem } from "../box-selection-item/box-selection-item.js";
const DonationFieldOption = (props) => {
  const { t } = useTranslation();
  const { price, inputId, ...rest } = props;
  const { currency, regionalFormat } = useConfig();
  const formattedCurrency = formatCurrency({
    amount: price,
    currency: currency?.code,
    locale: regionalFormat
  });
  return /* @__PURE__ */ jsx(
    BoxSelectionItem,
    {
      ...rest,
      inputId,
      content: formattedCurrency,
      "aria-label": `${getCurrencyAriaLabel(t, currency)} ${price}`
    }
  );
};
DonationFieldOption.includeCheckboxInBundle = Checkbox;
export {
  DonationFieldOption
};
//# sourceMappingURL=donation-field-option.js.map
